<template>
    <div class="entry-carousel">
        <div class="swiper-container swiper-container--entry-carousel">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div :key="index" class="w-1/3 swiper-slide card" v-for="(card, index) in cards">
                    <div class="card__image object-fit" v-html="card.image"></div>
                    <!--<p class="card__date" v-if="card.date">{{ card.date }}</p>-->
                    <h5 class="card__title" v-if="card.title">{{ card.title }}</h5>
                    <div class="rte card__text" v-html="card.text" v-if="card.text"></div>
                    <a :href="card.url" class="card__read-more" v-if="card.contentAvailable">Verder lezen</a>
                </div>
            </div>
        </div>
        <div class="buttons">
            <svg class="buttons__prev-slide" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 57 1)">
                    <circle cx="28" cy="28" r="28" stroke="#1A3A1B"/>
                    <path d="M44.5 27.41a4.91 4.91 0 01-4.904-4.679l-.005-.231H38.5a5.994 5.994 0 002.684 5.001L12.5 27.5v1h28.683a5.994 5.994 0 00-2.683 5h1.09l.006-.231A4.91 4.91 0 0144.5 28.59v-1.182z"
                          fill="#0B1B0C" fill-rule="nonzero"/>
                </g>
            </svg>
            <svg class="buttons__next-slide" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
                    <circle cx="28" cy="28" r="28" stroke="#1A3A1B"/>
                    <path d="M44.5 27.41a4.91 4.91 0 01-4.904-4.679l-.005-.231H38.5a5.994 5.994 0 002.684 5.001L12.5 27.5v1h28.683a5.994 5.994 0 00-2.683 5h1.09l.006-.231A4.91 4.91 0 0144.5 28.59v-1.182z"
                          fill="#0B1B0C" fill-rule="nonzero"/>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper/bundle';

    export default {
        props: {
            cards: {
                type: Array,
                default: () => []
            },
        },
        mounted() {
            const entryCarousels = document.querySelectorAll('.entry-carousel');
            for (let block of entryCarousels) {
                const carContainer = block.getElementsByClassName('swiper-container--entry-carousel')[0];
                const btnNext = block.getElementsByClassName('buttons__next-slide')[0];
                const btnPrev = block.getElementsByClassName('buttons__prev-slide')[0];
                new Swiper(carContainer, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 20,


                    navigation: {
                        nextEl: btnNext,
                        prevEl: btnPrev,
                    },

                    breakpoints: {
                        650: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 60,
                        }
                    },
                });
            }
        }
    }
</script>